<div class="col-xs-12 p-0" *ngIf="activeRegimens.length">
  <div class="col-xs-12 title flex justifySB alignC" (click)="isExpanded = !isExpanded">
    <span><em class="fas fa-redo title bold pr-3"></em>Regimen Reorder</span>
    <div class="dropDownIcon" [ngClass]="{'rotate': isExpanded}"><i class="fas fa-chevron-right fontL1"></i></div>
  </div>
  <div class="col-xs-12 pt-1" *ngIf="isExpanded">
    <div class="col-xs-3">
      <p class="pt-1 pr-1 bold">Create Initial order:</p>
    </div>
    <div class="col-xs-4">
      <button class="btn btn-xs btn-primary mr-2"
        *ngFor="let regimen of activeRegimens"
        [disabled]="isCreating"
        (click)="createInitialOrder(regimen)">
          {{ regimen.get('class') }}
        </button>
    </div>
  </div>
</div>
